import React from 'react';
import { useTheme } from 'styled-components';
import Badge from '../badge';
import { AbstractTabItemProps } from './tabs.types';

type TabItemProps = Pick<AbstractTabItemProps, 'label' | 'Icon' | 'badge'>;

const TabItem: React.FunctionComponent<TabItemProps> = ({ label, Icon, badge }) => {
  const theme = useTheme();

  return (
    <span style={{ display: 'flex', alignItems: 'center' }}>
      {Icon ? (
        <Icon
          width={24}
          height={24}
          color={theme.color.state.active}
          style={{ marginRight: theme.spacings.component.XXS }}
        />
      ) : null}
      {label}
      {badge ? (
        <Badge
          content={badge}
          maxCount={99}
          badgeStyle={{ display: 'inline-flex', marginLeft: theme.spacings.component.XXS }}
        />
      ) : null}
    </span>
  );
};

export default TabItem;
